import React, { FC } from "react";
import { Flex } from "@chakra-ui/layout";
import { Spinner, SpinnerProps } from "@chakra-ui/spinner";

type Props = SpinnerProps & {
  color?: string;
};

export const LoadingScreen: FC<Props> = ({
  size = "xl",
  color = "seaGreen.500",
}) => {
  return (
    <Flex
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center"
      paddingY="10"
      data-testid="loading-screen"
    >
      <Spinner
        color={color}
        emptyColor="gray.200"
        thickness="4px"
        speed="0.65s"
        size={size}
      />
    </Flex>
  );
};
